const items = [
  "Consumer Brands",
  "Brand Strategy",
  "Patient Growth",
  "Cultural Insight",
  "Grounded Marketing",
  "Creative Craft",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section
      data-testid="marquee-section"
      className="bg-[#1C1C19] text-[#F7F5F0] py-8 border-y border-[#1C1C19] overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-marquee gap-16">
        {row.map((item, i) => (
          <div key={`${item}-${i}`} className="flex items-center gap-16 shrink-0">
            <span className="font-display italic text-3xl md:text-4xl font-light">
              {item}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#F2C14E] shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
}
